import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.css']
})
export class TableComponent implements OnInit {
  constructor() { }

  @Input() isLoading: boolean = true;
  @Input() columns: string[] = [];
  @Input() list: any[] = [];
  @Output() actionClicked = new EventEmitter<any>();
  @Output() actionEditClicked = new EventEmitter<any>();

  ngOnInit(): void {
    console.log(this.list);
  }

  setLoading(isLoading: boolean) {
    console.log('setLoading called:', isLoading);

    if (isLoading)
      this.list = [];

    this.isLoading = isLoading;
  }

  onViewClick(item: any) {
    this.actionClicked.emit(item);
  }

  onEditClick(item: any) {
    this.actionEditClicked.emit(item);
  }
}